export default {
    SET_CHANNEL: 'SET_CHANNEL',
    SET_CONFIG_DATA: 'SET_CONFIG_DATA',
    SET_DYNAMIC_CONTENT_SERIES_TITLES: 'SET_DYNAMIC_CONTENT_SERIES_TITLES',
    SET_EPG_PLAYER_MUTE: 'SET_EPG_PLAYER_MUTE',
    SET_VOD_PLAYER_MUTE: 'SET_VOD_PLAYER_MUTE',
    SET_SERIES_CODE: 'SET_SERIES_CODE',
    SET_COOKIE_CONSENT_STATUS: 'SET_COOKIE_CONSENT_STATUS',
}
